// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('TaxCodeReport/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('TaxCodeReport/getData', async (params, { dispatch }) => {

    dispatch(setLoading({ getData: true }))

    try {
        let response = await axios.get('/AccountsReports/GetTransactionSummaryByTaxCodeReport', {params})

        return {
            params,
            data: response.data,
        }
    }catch (e){
        console.log(e);
        return {
            params,
            data: {data: {
                list: []
            }}
        }
    }finally {
        dispatch(setLoading({ getData: false }))
    }

})

export const TaxCodeReportDetail = createSlice({
    name: 'TaxCodeReport',
    initialState: {
        data: [],
        totalRecords: 1,
        params: {},
        loadingState: { getData: false }
        // allData: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getData.fulfilled, (state, action) => {

                state.data = action.payload.data.data;
                state.totalRecords = action.payload.data.totalRecords;
                state.params = action.payload.params;
            })
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loadingState = action.payload;
            });
    },
})

export default TaxCodeReportDetail.reducer
